import { icon } from "../functions/icons";
import { StandardComp } from "../atoms/standardComp";
import { GridLayout, HorizontalLayout, VerticalLayout } from "./layout";
import { useContext, useEffect, useState } from "react";
import { TitleDescription } from "./titleDescription";
import { TitleDescriptionText } from "../atoms/titleDescription";
import { ProgressBarComplete } from "../molecule/timeBar";
import { PageContext } from "../App";

export function ScoreOverview({ exercises, data, title = "Score overzicht", compact = false }) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const navigationContext = useContext(PageContext);
    const publishPage = navigationContext.sidebar.navigation === 7 
    const isMobile = windowWidth < 768;
        useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
        }, []);

    return (
        isMobile && publishPage ? (
            <MobileScoreOverview exercises={exercises} data={data} title={title}/>
        ):(
            <DesktopScoreOverview data={data} title={title} compact={compact} />
        )
    );
}


const MobileScoreOverview = ({ data, title, exercises }) => {
    const correct = data?.passed_questions ?? 0;
    const total = data?.total_questions ?? exercises?.length ?? 0;
    const percentage = total > 0 ? ((correct / total) * 100).toFixed(0) : 0;
    const passed = percentage >= 50;

    return (
        <>
            <VerticalLayout className="mobile-score-progress-container">
                <TitleDescriptionText
                    className="mobile-score-progress-title flex space-between"
                    title={title}
                    description={`${correct}/${total}`}
                />
                <ProgressBarComplete barColor={passed ? "success-500" : "error-500"} progress={`${percentage}%`} />
            </VerticalLayout>
        </>
    );
};

const DesktopScoreOverview = ({ data, title, compact }) => {
    return(
         <VerticalLayout className={`${compact ? '' : 'standard-margin-bottom'} not-clickable`} style={compact ? { height: 'auto', marginBottom: 0 } : undefined}>
            <StandardComp 
                editClass={"no-margin-right"}
            content={
                <>
                <h6 className="score-overview-title standard-small-margin-bottom standard-text-color">{title}</h6>
            <StandardComp
            editClass={"no-margin-right"}
             style={{ backgroundColor: data.is_passed ? "var(--success-500)" : "var(--error-500)" }}
            content={
                <>
                <VerticalLayout style={{     
                    alignContent: "center",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--white)",
                    }}>
                      {icon(data.is_passed ? "finished" : "x-circle", 40)}
                    <p style={{ fontSize: "1.4rem", fontWeight: "600", textAlign: "center" }}> {data.is_passed ? "Geslaagd!" : "Gezakt!"}</p>
                </VerticalLayout>
                </>
            }
           />
            <GridLayout columnsTemplate="repeat(auto-fit, minmax(220px, 1fr))" gap="1rem" className="standard-margin-top grid-score-overview">
                    <StandardComp
                        editClass={"score-overview-card no-margin-right"}
                        content={
                            <>
                            {icon("star", 25, "var(--primary-500)")}
                            <p style={{ fontSize: "0.875rem", fontWeight: "300" }} className="standard-margin">Testvragen</p>
                            <p style={{ fontSize: "1rem", fontWeight: "600", textAlign: "center", width: "35%",}}>{data.passed_questions}/{data.total_questions} goed beantwoord!</p>
                            </>
                        }
                    />
                    <StandardComp
                        editClass={"score-overview-card no-margin-right"}
                        content={
                            <>
                            {icon("clock", 25, "var(--primary-500)")}
                            <p style={{ fontSize: "0.875rem", fontWeight: "300" }} className="standard-margin">Tijdslimiet</p>
                            <p style={{ fontSize: "1rem", fontWeight: "600" , textAlign: "center" , width: "35%",}}>{data.on_time ? "Binnen de tijd klaar!" : "Te laat ingeleverd!"}</p>
                            </>
                        }
                    />
                    <StandardComp
                        editClass={"score-overview-card no-margin-right"}
                        content={
                                <>
                                {icon("brain", 25, "var(--primary-500)")}
                                <p style={{ fontSize: "0.875rem", fontWeight: "300" }} className="standard-margin">Skills</p>
                                <p style={{ fontSize: "1rem", fontWeight: "600", textAlign: "center" , width: "35%", }}>{data.passed_questions ? data.passed_questions : "Geen"} skills geleerd!</p>
                                </>
                            }
                    />
            </GridLayout>
                </>
            }/>
        </VerticalLayout>
    )
}